// FØRST: `chorus.*` → `tvitvi.*` i lagringen, før noe under leser den (navnebyttet, oktober 2026).
import './lib/legacy-storage-boot';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import './styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
